// top level orchestration - for the app
var controllerEvents = require('ControllerEvents');
var DiagnosticsController = require('./DiagnosticsController.js');
var lsbridge = require('lsbridge');
var tree     = require('tree/tree.js');


var AppController = function (_, ko, core, callStateService, helpers, events, interControllerEmitter, console) {

    var self = this;
    self.params = null;
    self.CurrentGalleryDetails = null;


    var Promise = core.Promise
        , moment = core.Moment
        , timestamp = function () { return helpers.timeStamp(moment) }


    var _searchServerController, searchServerController = function () { return _searchServerController },
    diagnosticsController = new DiagnosticsController(self, _, ko, core, helpers, console, events);
    ///////////////////////////////////////////////////
    var _default = true


    self.init = function (params, startupState, applicationStateController, __searchServerController) {

        console.info('initialisation',self, params, startupState, applicationStateController, __searchServerController);

        _.assign(self, {
                  params                     : params
                , applicationStateController : applicationStateController
                , getApplicationState        : applicationStateController.getApplicationState
        });

        _.assign(diagnostics,
                {applicationStateController: applicationStateController }
                );
        _searchServerController = __searchServerController;

        var tryGalleryKey = _.at(startupState, 'info.GalleryKey')[0] || params.galleryKey;


        return tryGalleryKey

            ? saveGalleryKey(tryGalleryKey)

            :self.applicationStateController.getCurrentGalleryKey()
                .then(function(currentGalleryKey){
                    if (currentGalleryKey){
                    self.setCurrentGallery(currentGalleryKey);
                    return  _searchServerController.getGalleryDetails(currentGalleryKey.galleryKey);
                    }
                    else {
                        return params.galleryKey ? saveGalleryKey(params.galleryKey)
                            :  Promise.resolve({ result: 'Gallery not set' });
                    }
                });

    }

    self.setCurrentGallery = function (gallerykeyInfo) {

        var storageProvider = ko.storage.createStorageProvider('splash', 'guest', 7 * 24 * 60 * 60000);

        storageProvider.store('Prop1', gallerykeyInfo.GalleryKey);

        self.CurrentGalleryDetails = gallerykeyInfo;
    }



    interControllerEmitter.on(controllerEvents.user_logout, function () {

        lsbridge.send(controllerEvents.user_logout, { logMeOut: '' });

    });

    events.emitter.on(events.gallery_splash_selected, function () {
        interControllerEmitter.emit(controllerEvents.splashscreen_view_request);
    });

    var requestSplitView = function (args) {


        var data = { LeftHandView: 'PictureFilters', RightHandView: 'PictureGrid' }
        interControllerEmitter.emit(controllerEvents.split_view_request, args ? _.assign(data, args) : data);

    };

    events.emitter.on(events.gallery_home_selected, requestSplitView);

    var saveGalleryKey = function (galleryKey) {

        console.warn('request to save new gallery key', galleryKey);
        return searchServerController().getGalleryDetails(galleryKey)
            .then(function (galleryDetails) {
                console.warn("uffff", galleryDetails);
                if (galleryDetails) {
                    return self.applicationStateController.saveGalleryKey(galleryKey, galleryDetails.Name, true)
                        .then(function () {
                            var result = galleryDetails;
                            self.setCurrentGallery(galleryDetails);
                            interControllerEmitter.emit(controllerEvents.gallery_details_loaded, result);
                            requestSplitView({ GalleryKey: galleryKey, GalleryDetails: galleryDetails });
                            
                        });


                } else {
                    interControllerEmitter.emit(controllerEvents.gallery_details_loaded, null);
                }

            })

    }

    events.emitter.on(events.gallery_save_key, saveGalleryKey);


    events.emitter.on(events.gallery_details_requested, function () {
        var galleryDetails = self.CurrentGalleryDetails;
        if (galleryDetails) {
            searchServerController().getGalleryDetails(galleryDetails.GalleryKey)
            .then(function(details){
                self.setCurrentGallery(details);
            });
        } else {
            interControllerEmitter.emit(controllerEvents.gallery_details_loaded, null);
        }

    });

    events.emitter.on(events.picture_filters_view_initialized, function () {
        if (!self.CurrentGalleryDetails) return;

        searchServerController()
            .loadPrimaryFilters(self.CurrentGalleryDetails.GalleryKey, self.CurrentGalleryDetails.PrimaryDateFilterField)
            .then(function(_filters){
                    console.warn('blah: primary filters built', _filters);
                    interControllerEmitter.emit(controllerEvents.primary_filters_loaded, _filters, self.CurrentGalleryDetails.GalleryKey);
            });
    });

    events.emitter.on(events.gallery_filters_requested, function (transportReady) {
        //Hopefully at this point we know the date range we are interested in to ass through to the filter and cascade fetching.

        // "[{"Key":"VisitDate__$RANGESTART__","Value":"2021-02-14"},{"Key":"VisitDate__$RANGEEND__","Value":"2021-02-16"}]"
        var primaryFilters = JSON.parse(transportReady);
        var visitDateFrom = _.result(_.find(primaryFilters, function(primaryFilter){ return primaryFilter.Key === 'VisitDate__$RANGESTART__';}), 'Value');
        var visitDateTo = _.result(_.find(primaryFilters, function(primaryFilter){ return primaryFilter.Key === 'VisitDate__$RANGEEND__';}), 'Value');
        
        var galleryDetails = self.CurrentGalleryDetails
        if (!galleryDetails) return;

        var filters;

        searchServerController()
            .loadFilters(galleryDetails.GalleryKey, galleryDetails.PrimaryDateFilterField, visitDateFrom, visitDateTo)
            .then(function(_filters){

                filters = _filters;

                return tree.CascadeSetNamesFromFilters(filters);

            })
            .then(function(cascadeSets){
                console.log('sets', cascadeSets);
                return global.mutex.synchronize(function(){
                    return Promise.all(_.map(cascadeSets,
                        function(setName){ return searchServerController().getMapping(galleryDetails.GalleryKey, setName, galleryDetails.PrimaryDateFilterField, visitDateFrom, visitDateTo) }
                        )
                    );
                });
            })

            .then(function (mappings){

                interControllerEmitter.emit(controllerEvents.gallery_filters_loaded, filters, mappings);
            });

    });

    events.emitter.on(events.find_pictures, function (filterData) {

         var galleryDetails = self.CurrentGalleryDetails
                if (galleryDetails) {
                    searchServerController().findPictures(galleryDetails.GalleryKey, filterData).then(function (filters) {
                        var result = filters;
                        interControllerEmitter.emit(controllerEvents.gallery_page_data_loaded, result);

                    });
                }
            });

    events.emitter.on(events.get_gallery_data_page, function (pageInfo) {
        searchServerController().getPicturePage(self.CurrentGalleryDetails.GalleryKey, pageInfo).then(function (filters) {
            var result = filters;
            interControllerEmitter.emit(controllerEvents.gallery_page_data_loaded, result);

        });
    });


    var emitCount = function(count){ events.emitter.emit(events.selection_count, count) }

    events.emitter.on(events.set_picture_selection_state, function (selectionInfo) {
        //console.error("setting selection state: ", JSON.stringify(selectionInfo) );

        (function(){

            if(selectionInfo.get_count   ) return searchServerController().getCount()
            if(selectionInfo.unselect_all) return searchServerController().unselectAll()
            if(selectionInfo.select_list ) return searchServerController().setPictureListSelectionState(selectionInfo.select_list, selectionInfo.Selected)

            return searchServerController().setPictureSelectionState(selectionInfo.PictureId, selectionInfo.Selected);

        })().then(emitCount);

    });

    events.emitter.on(events.request_bulk_picture_download, function (downloadOptions) {
        console.warn("requesting bulk picture download: ", downloadOptions);
       self.applicationStateController.getCurrentGalleryKey()
       .then(function(currentGalleryKey){
             searchServerController().downloadPictures(currentGalleryKey.GalleryKey,currentGalleryKey.ClientToken,downloadOptions);
       })

    });
    events.emitter.on(events.request_bulk_picture_update, function (statusChangeOptions) {
        console.warn("requesting picture status change: ", statusChangeOptions);
       self.applicationStateController.getCurrentGalleryKey()
       .then(function(currentGalleryKey){
             searchServerController().changeStatusOfPictures(currentGalleryKey.GalleryKey, self.ContentManagerCode(),statusChangeOptions);
       })

    });
    self.ContentManagerCode = ko.observable();
    self.AuthorViewMode     = ko.observable();

    events.emitter.on(events.manager_code_set, self.ContentManagerCode);
    events.emitter.on(events.view_mode_change, function (viewMode) {

        self.AuthorViewMode(viewMode === 'Author');

    });
    events.emitter.on(events.log_out, function(){

        console.log('application controller - log out -');

        self.applicationStateController.logOut().then(function(){

            interControllerEmitter.emit(controllerEvents.splashscreen_view_request);

        });
    })

    lsbridge.subscribe(controllerEvents.user_logout, function (data) {

        console.log(data);
        sessionInitializer.onLogOut();
        resetEventWith(markInvalidSessionState);

    });


    lsbridge.subscribe(events.authentication, function (sessionUpdate) {

        if (!lsbridgeSelf) {
            console.error('other tab authenticated', sessionUpdate);
            resetEventWith(function (state) { return self.assignToState(state, sessionUpdate) });
        }
        lsbridgeSelf = false;

    });

    window.addEventListener("unhandledrejection", function (err, promise) {

        console.log('super unhandled exception caught here', err, promise);
        console.warn('super unhandled exception caught here', err, promise);
        console.error('super unhandled exception caught here', err, promise);
    });


}

module.exports = AppController;